import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { bindActionCreators } from 'redux'
import Typo from 'constants/typography'
import Loader from 'components/loader'
import ReferralsAPI from 'lib/api/referrals'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { REFERRAL_HISTORY_LOCIZE, REFERRAL_ORDER_STATUS } from './const'
import ReferralHistoryTab from './history-tab'
import ReferralHistoryContent from './content'
import referralHistoryDuck from './duck'
import styles from './styles.scss'

const ReferralHistory = ({
  orderCount,
  updateReferralOrder,
  resetReferralOrder,
  t,
}) => {
  useEffect(() => {
    ReferralsAPI.getReferralOrders()
      .then((res) => {
        const { orders_count, orders } = res
        const filterOrderByStatus = (status) =>
          orders.filter(
            (order) => order.order_status === REFERRAL_ORDER_STATUS[status],
          )

        updateReferralOrder(
          orders_count,
          filterOrderByStatus('IN_PROGRESS'),
          filterOrderByStatus('SUCCESS'),
          filterOrderByStatus('IN_COMPLETE'),
        )
      })
      .catch(() => {
        resetReferralOrder()
      })
  }, [updateReferralOrder, resetReferralOrder])

  return (
    <div className="referral-history">
      <style jsx>{styles}</style>
      <div className="referral-history__wrapper">
        <span className={Typo.title3}>
          {hasLocizeTranslation(
            t,
            REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_TITLE.key,
            REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_TITLE.text,
          )}
        </span>
        <span className={Typo.body2}>
          {hasLocizeTranslation(
            t,
            REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_SUB_TITLE.key,
            REFERRAL_HISTORY_LOCIZE.REFERRAL_HISTORY_SUB_TITLE.text,
          )}
        </span>
        <ReferralHistoryTab />
        {Object.keys(orderCount).length === 0 ? (
          <div className="loader-container">
            <Loader />
          </div>
        ) : (
          <ReferralHistoryContent />
        )}
      </div>
    </div>
  )
}

ReferralHistory.propTypes = {
  orderCount: PropTypes.shape({}).isRequired,
  updateReferralOrder: PropTypes.func.isRequired,
  resetReferralOrder: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect(
    (state) => ({
      orderCount: state.referralHistory.orderCount,
    }),
    (dispatch) =>
      bindActionCreators(
        {
          updateSelectedTab: referralHistoryDuck.creators.updateSelectedTab,
          updateReferralOrder: referralHistoryDuck.creators.updateReferralOrder,
          resetReferralOrder: referralHistoryDuck.creators.resetReferralOrder,
        },
        dispatch,
      ),
  ),
  withI18next(),
)(ReferralHistory)
